import { get } from 'lodash';

export default (error, errTypes) => error.graphQLErrors
  .some(e => errTypes.includes(Number(get(e, 'extensions.code'))));
